/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'clear': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z" _fill="#E42F4A" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/clear.js